// extracted by mini-css-extract-plugin
module.exports = {"container":"PageInProgress_container_1NxG0","title":"PageInProgress_title_1odIp","subtitle":"PageInProgress_subtitle_39GLU","icon":"PageInProgress_icon_1Swb6"};